import CompanionSummary, {
  CompanionSummaryProps,
} from 'components/CompanionSummary/CompanionSummary';

export type {CompanionSummaryProps};
export default CompanionSummary;
